import { storage } from '../utils/storage/storage.utils';
import { StorageObjectMap } from '../utils/storage/storage.types';

export type AppSessionState = StorageObjectMap['appSession'];

export const initialAppSessionState: AppSessionState | null = storage.getItem('appSession');
